import React from 'react';
import ProductReviewsDesktop from './ProductReviewsDesktop';
import ProductReviewsMobile from './ProductReviewsMobile';

const ProductReviews = (props: any) => {
  const {
    isDesktop = false,
    textReview,
    totalReviews,
    imageReview,
    totalRatingCount,
    totalStarCount,
    isProgressBar,
    rateData,
    noReviews,
    subRatings,
    brickCode,
    aggregateRating,
    titleD,
    images,
    featureData,
    mandatoryInfo,
    luxe,
    isSneakerHoodOn,
    sneakerHoodFeatureDataList,
    productCode,
    productName,
    productBrand,
    product_id,
    product_brick,
    getAggregateRating,
    getSubRatings,
    imageUrl,
    customerWords,
    isSignedIn,
    subRating,
    productData,
    isFleek = false
  } = props;
  return (
    <>
      {isDesktop ? (
        <ProductReviewsDesktop
          totalRatingCount={totalRatingCount}
          totalStarCount={totalStarCount}
          isProgressBar={isProgressBar}
          rateData={rateData}
          isDesktop={true}
          customerWords={customerWords}
          textReview={textReview}
          totalReviews={totalReviews}
          imageReview={imageReview}
          noReviews={noReviews}
          subRating={subRating}
          titleD={titleD}
          productCode={productCode}
          productName={productName}
          product_id={product_id}
          product_brick={product_brick}
          images={images}
          aggregateRating={aggregateRating}
          productData={productData}
        />
      ) : (
        <ProductReviewsMobile
          totalRatingCount={totalRatingCount}
          totalStarCount={totalStarCount}
          isProgressBar={isProgressBar}
          rateData={rateData}
          customerWords={customerWords}
          textReview={textReview}
          totalReviews={totalReviews}
          imageReview={imageReview}
          noReviews={noReviews}
          subRating={subRatings ? subRatings : ''}
          titleD={titleD}
          productCode={productCode}
          productName={productName}
          product_id={product_id}
          product_brick={product_brick}
          images={images}
          aggregateRating={aggregateRating ? aggregateRating : ''}
          isDesktop={false}
          featureData={featureData}
          mandatoryInfo={mandatoryInfo}
          luxe={luxe}
          isSneakerHoodOn={isSneakerHoodOn}
          sneakerHoodFeatureDataList={sneakerHoodFeatureDataList}
          productBrand={productBrand}
          getAggregateRating={getAggregateRating}
          getSubRatings={getSubRatings}
          imageUrl={imageUrl}
          isSignedIn={isSignedIn}
          isFleek={isFleek}
          productData={productData}
        />
      )}
    </>
  );
};

export default ProductReviews;
